import { render, staticRenderFns } from "./CreatorShopPostsTab.vue?vue&type=template&id=106a5224"
import script from "./CreatorShopPostsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatorShopPostsTab.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopTrendingPostsSlidegroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/trending-posts/TrendingPostsSlidegroup.vue').default,SplitTest: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/SplitTest.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,CreatorShopCollectionLtkCollectionSlidegroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/collection/LtkCollectionSlidegroup.vue').default,CreatorShopPostFeed: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/post-feed/PostFeed.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,CContainer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CContainer.vue').default})
